/**
 * Types for the Configuration -> Managers page and the NearestManagers endpoint behind it.
 */

export const MANAGER_BY_EMPLOYEE = "MANAGER_BY_EMPLOYEE";
export const EMPLOYEE_BY_MANAGER = "EMPLOYEE_BY_MANAGER";

/** Which side of the relation the list leads with. */
export type NearestManagerMode = typeof MANAGER_BY_EMPLOYEE | typeof EMPLOYEE_BY_MANAGER;

/** One employee paired with the manager nearest to them. */
export interface NearestManagerRow {
    employeeFirstName: string;
    employeeLastName: string;
    employeeEmail: string;
    managerFirstName: string;
    managerLastName: string;
    managerEmail: string;
}

export interface NearestManagersResponse {
    /** the page that was served, echoed back by the endpoint */
    page: number;
    /** number of pages the matching rows span */
    total: number;
    /** number of matching rows, across every page */
    records: number;
    rows: NearestManagerRow[];
}
